import axios from 'axios';
import { Config } from '../config';
import userStore from '../store/userStore';
import { addNotification } from '../action/notificationAction';
import getHeaders from './header';

/**
 * takes the customer object from the admin center and pushes it up to the server
 * @param {*} customerObject 
 */
export function addCustomer(customerObject) {
    return new Promise(async (resolve, reject) => {
        const url = Config[Config.env].functionappurl + "api/dohertyPortal?createCustomer=true&userId=" + userStore.user.id;
        const headers = await getHeaders();

        axios.post(url, customerObject, { headers: headers }).then((response) => {
            resolve(response.data);
        }).catch((e) => {
            if (e.response) {
                if (e.response.status === 401) {
                    reject(e.response.status);
                } else {
                    reject(e.response.data);
                }
            } else {
                reject("Internal error, please try again");
            }
        });
    });
}

/**
 * Adds a customers user to a customer so that the user can login
 * @param {*} email email of the user to log in
 * @param {*} companyId company you want to log into
 */
export async function addCustomerUser(email, companyId) {
    const url = Config[Config.env].functionappurl + "api/dohertyPortal?createUser=" + companyId + "&userId=" + userStore.user.id;
    const headers = await getHeaders();

    axios.post(url, { email }, { headers }).then((res) => {
        addNotification({ status: "success", message: "Successfully saved user: " + email });
    }).catch((e) => {
        addNotification({ status: "fail", message: "Could not add user" });
    });
}

/**
 * changing the stage
 * @param {*} type type of change add or remove
 * @param {*} companyId company to alter the stage of
 */
export async function changeStage(type, companyId) {
    return new Promise(async (resolve, reject) => {
        const url = Config[Config.env].functionappurl + "api/staging?changeStage=" + companyId + "&userId=" + userStore.user.id;
        const headers = await getHeaders();

        axios.post(url, { stage: type }, { headers }).then((res) => {
            addNotification({ status: "success", message: "Successfully updated the stage" });
            resolve(res.data);
        }).catch((e) => {
            addNotification({ status: "fail", message: "Could not update stage" });
            reject();
        });
    });
}
/**
 * retrieves all the companies for the admin controller
 */
export function getCompanies() {
    return new Promise(async (resolve, reject) => {
        const url = Config[Config.env].functionappurl + "api/dohertyPortal?getCompanies=true&userId=" + userStore.user.id;
        const headers = await getHeaders();

        axios.get(url, { headers: headers }).then((response) => {
            resolve(response.data);
        }).catch((e) => {
            if (e.response) {
                if (e.response.status === 401) {
                    reject(e.response.status);
                } else {
                    reject(e.response.data);
                }
            } else {
                reject("Internal error, please try again");
            }
        });
    });
}
export async function updateTenantInfo(tenantInfo, companyId) {
    const url = Config[Config.env].functionappurl + "api/dohertyPortal?updateTenantInfo=" + companyId + "&userId=" + userStore.user.id;
    const headers = await getHeaders();

    const response = await axios.post(url, tenantInfo, { headers: headers });
    return response.data;
};


// WEBPACK FOOTER //
// ./src/services/customer.js